// extracted by mini-css-extract-plugin
module.exports = {"botonera":"Paginado_botonera__2nsEn","botoneraContent":"Paginado_botoneraContent__2BHTP"};